module.exports = __webpack_public_path__ + "media/images/common/ok_btn_l_ov-67b9eecd40cd37bc97844fb2bded4283.png";